import { useContext, useState, useEffect } from "react";
import axios from "axios";
import { AuthContext } from "../../Context/AuthContext";

export default function useCloseConcern() {
  const { token } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const closeConcern = async (concernId, response) => {
    setLoading(true);
    setError(null);

    try {
      const res = await axios.patch(
        `${process.env.REACT_APP_SERVER_URL}/raise/concerns/${concernId}/close`,
        { response },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return res.data;
    } catch (err) {
      setError(err.response?.data?.message || "Something went wrong.");
      throw err;
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (error) {
      const timer = setTimeout(() => {
        setError(null);
      }, 3000);

      return () => clearTimeout(timer);
    }
  }, [error]);

  return { closeConcern, loading, error };
}
